export const legendConfig = [
  {
    color: '#FF4D4F',
    label: 'Major Incidents',
    key: 'major',
    toggled: true,
  },
  {
    color: '#FADB14',
    label: 'Minor Incidents',
    key: 'minor',
    toggled: true,
  },
  {
    color: '#FA8C16',
    label: 'Moderate Incidents',
    key: 'moderate',
    toggled: true,
  },
  {
    color: '#52C41A',
    label: 'Corrective Actions',
    key: 'riskMitigationMeasures',
    toggled: true,
  },
];
